<ham-accordion>
    <ham-accordion-item
        [isOpened]="openedPrintOptionsAccordions.consistencyChecksAccordion"
        (opened)="onToggleAccordion()"
        (closed)="onToggleAccordion()"
        #accordion
    >
        <div accordion-header>
            <span class="accordion-header-content">
                <span
                    hamIconShapes
                    class="shield-check-icon"
                    icon="assets/hamIcons/shield-check.svg"
                    [variant]="'transparent'"
                    [size]="'regular'"
                >
                </span>
                <span>
                    {{ 'aumico_reports_equality_check_print_preview_title' | i18next }}
                </span>
            </span>
            <span class="accordion-icon">
                <span
                    *ngIf="!isAccordionExpanded"
                    class="chevron-down"
                    hamIconShapes
                    icon="assets/hamIcons/chevron-down.svg"
                    [variant]="'transparent'"
                    [size]="'regular'"
                    (click)="accordion.onToggle()"
                ></span>
                <span
                    *ngIf="isAccordionExpanded"
                    hamIconShapes
                    class="chevron-up-outline"
                    icon="assets/hamIcons/chevron-up-outline.svg"
                    [variant]="'transparent'"
                    [size]="'regular'"
                    (click)="accordion.onToggle()"
                ></span>
            </span>
        </div>
        <div accordion-body>
            <div class="table-row">
                <div></div>
                <div class="dates-row">
                    <span> {{ currentYear }} </span>
                    <span class="date">
                        <ng-container *ngIf="!noPreviousYear"> {{ previousYear }} </ng-container>
                    </span>
                </div>
            </div>
            <div>
                <div
                    class="table-row"
                    data-testid="consistency-check-assets-equal-liabilities"
                    [attr.data-consistent-current]="equalityCheckDataCurrentYear.isMappingAssetsAndLiabilitiesConsistent"
                    [attr.data-consistent-previous]="noPreviousYear ? null : equalityCheckDataPreviousYear.isMappingAssetsAndLiabilitiesConsistent"
                >
                    <div class="row-label">
                        {{ 'aumico_reports_equality_check_print_preview_table_assets_equal_liabilities' | i18next }}
                    </div>
                    <div>
                        <span
                            *ngIf="equalityCheckDataCurrentYear.isMappingAssetsAndLiabilitiesConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/check-outline.svg"
                            [variant]="'dark-green'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <span
                            *ngIf="!equalityCheckDataCurrentYear.isMappingAssetsAndLiabilitiesConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/x-red.svg"
                            [variant]="'dark-red'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <ng-container *ngIf="!noPreviousYear">
                            <span
                                *ngIf="equalityCheckDataPreviousYear.isMappingAssetsAndLiabilitiesConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/check-outline.svg"
                                [variant]="'dark-green'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                            <span
                                *ngIf="!equalityCheckDataPreviousYear.isMappingAssetsAndLiabilitiesConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/x-red.svg"
                                [variant]="'dark-red'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                        </ng-container>
                    </div>
                </div>

                <div class="divider"></div>

                <div
                    class="table-row"
                    data-testid="consistency-check-profit"
                    [attr.data-consistent-current]="equalityCheckDataCurrentYear.isMappingProfitIncomeAndProfitFliConsistent"
                    [attr.data-consistent-previous]="noPreviousYear ? null : equalityCheckDataPreviousYear.isMappingProfitIncomeAndProfitFliConsistent"
                >
                    <div class="row-label">
                        {{
                            'aumico_reports_equality_check_print_preview_table_profit_income_equals_profit_fli'
                                | i18next
                        }}
                    </div>
                    <div>
                        <span
                            *ngIf="equalityCheckDataCurrentYear.isMappingProfitIncomeAndProfitFliConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/check-outline.svg"
                            [variant]="'dark-green'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <span
                            *ngIf="!equalityCheckDataCurrentYear.isMappingProfitIncomeAndProfitFliConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/x-red.svg"
                            [variant]="'dark-red'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <ng-container *ngIf="!noPreviousYear">
                            <span
                                *ngIf="equalityCheckDataPreviousYear.isMappingProfitIncomeAndProfitFliConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/check-outline.svg"
                                [variant]="'dark-green'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                            <span
                                *ngIf="!equalityCheckDataPreviousYear.isMappingProfitIncomeAndProfitFliConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/x-red.svg"
                                [variant]="'dark-red'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                        </ng-container>
                    </div>
                </div>

                <div class="divider"></div>

                <div
                    *ngIf="equalityCheckDataCurrentYear.isCashflowStatementTotalsConsistent != null"
                    class="table-row"
                    data-testid="consistency-check-cashflow"
                    [attr.data-consistent-current]="equalityCheckDataCurrentYear.isCashflowStatementTotalsConsistent"
                    [attr.data-consistent-previous]="noPreviousYear ? null : equalityCheckDataPreviousYear.isCashflowStatementTotalsConsistent"
                >
                    <div class="row-label">
                        {{ 'aumico_reports_equality_check_print_preview_table_cashflow_statement' | i18next }}
                    </div>
                    <div>
                        <span
                            *ngIf="equalityCheckDataCurrentYear.isCashflowStatementTotalsConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/check-outline.svg"
                            [variant]="'dark-green'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <span
                            *ngIf="!equalityCheckDataCurrentYear.isCashflowStatementTotalsConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/x-red.svg"
                            [variant]="'dark-red'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <ng-container *ngIf="!noPreviousYear">
                            <span
                                *ngIf="equalityCheckDataPreviousYear.isCashflowStatementTotalsConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/check-outline.svg"
                                [variant]="'dark-green'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                            <span
                                *ngIf="!equalityCheckDataPreviousYear.isCashflowStatementTotalsConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/x-red.svg"
                                [variant]="'dark-red'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                        </ng-container>
                    </div>
                </div>
                <div
                    class="divider"
                    *ngIf="equalityCheckDataCurrentYear.isCashflowStatementTotalsConsistent != null"
                ></div>
                <!-- REV-20899: Reclassifications are always balanced by construction (transactional double-entry). Row removed. -->
                <div
                    *ngIf="equalityCheckDataCurrentYear.isAdjustmentsAssetsAndLiabilitiesConsistent != null"
                    class="table-row"
                    data-testid="consistency-check-adjustments"
                    [attr.data-consistent-current]="equalityCheckDataCurrentYear.isAdjustmentsAssetsAndLiabilitiesConsistent"
                    [attr.data-consistent-previous]="noPreviousYear ? null : equalityCheckDataPreviousYear.isAdjustmentsAssetsAndLiabilitiesConsistent"
                >
                    <div class="row-label">
                        {{ 'aumico_reports_equality_check_print_preview_table_adjustments' | i18next }}
                    </div>
                    <div>
                        <span
                            *ngIf="equalityCheckDataCurrentYear.isAdjustmentsAssetsAndLiabilitiesConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/check-outline.svg"
                            [variant]="'dark-green'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <span
                            *ngIf="!equalityCheckDataCurrentYear.isAdjustmentsAssetsAndLiabilitiesConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/x-red.svg"
                            [variant]="'dark-red'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <ng-container *ngIf="!noPreviousYear">
                            <span
                                *ngIf="equalityCheckDataPreviousYear.isAdjustmentsAssetsAndLiabilitiesConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/check-outline.svg"
                                [variant]="'dark-green'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                            <span
                                *ngIf="!equalityCheckDataPreviousYear.isAdjustmentsAssetsAndLiabilitiesConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/x-red.svg"
                                [variant]="'dark-red'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                        </ng-container>
                    </div>
                </div>
                <div
                    class="divider"
                    *ngIf="equalityCheckDataCurrentYear.isAdjustmentsAssetsAndLiabilitiesConsistent != null"
                ></div>
                <!-- REV-20899: Reclassifications are always balanced by construction (transactional double-entry). Row removed. -->
                <div
                    *ngIf="equalityCheckDataCurrentYear.isAdjustmentsProfitIncomeAndProfitFliConsistent != null"
                    class="table-row"
                    data-testid="consistency-check-adjustments-profit"
                    [attr.data-consistent-current]="equalityCheckDataCurrentYear.isAdjustmentsProfitIncomeAndProfitFliConsistent"
                    [attr.data-consistent-previous]="noPreviousYear ? null : equalityCheckDataPreviousYear.isAdjustmentsProfitIncomeAndProfitFliConsistent"
                >
                    <div class="row-label">
                        {{
                            'aumico_reports_equality_check_print_preview_table_adjustments_profit_income_equals_adjustments_profit_balance'
                                | i18next
                        }}
                    </div>
                    <div>
                        <span
                            *ngIf="equalityCheckDataCurrentYear.isAdjustmentsProfitIncomeAndProfitFliConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/check-outline.svg"
                            [variant]="'dark-green'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <span
                            *ngIf="!equalityCheckDataCurrentYear.isAdjustmentsProfitIncomeAndProfitFliConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/x-red.svg"
                            [variant]="'dark-red'"
                            [size]="'xs'"
                            class="check-icons icons-when-opened"
                            stopPropagation
                        >
                        </span>
                        <ng-container *ngIf="!noPreviousYear">
                            <span
                                *ngIf="equalityCheckDataPreviousYear.isAdjustmentsProfitIncomeAndProfitFliConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/check-outline.svg"
                                [variant]="'dark-green'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                            <span
                                *ngIf="!equalityCheckDataPreviousYear.isAdjustmentsProfitIncomeAndProfitFliConsistent"
                                class="icon"
                                hamIconShapes
                                icon="assets/hamIcons/x-red.svg"
                                [variant]="'dark-red'"
                                [size]="'xs'"
                                class="check-icons icons-when-opened-previous"
                                stopPropagation
                            >
                            </span>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div accordion-body-closed *ngIf="!isAccordionExpanded">
            <div class="dates-header-row">
                <span> {{ currentYear }} </span>
                <span *ngIf="!noPreviousYear"> {{ previousYear }} </span>
            </div>
            <div class="icons-row">
                <span>
                    <span
                        *ngIf="equalityCheckDataCurrentYear.isMappingAssetsAndLiabilitiesConsistent"
                        hamIconShapes
                        icon="assets/hamIcons/check-outline.svg"
                        [variant]="'dark-green'"
                        [size]="'xs'"
                        class="check-icons icons-when-closed"
                        stopPropagation
                    >
                    </span>
                    <span
                        *ngIf="!equalityCheckDataCurrentYear.isMappingAssetsAndLiabilitiesConsistent"
                        hamIconShapes
                        icon="assets/hamIcons/x-red.svg"
                        [variant]="'dark-red'"
                        [size]="'xs'"
                        class="check-icons icons-when-closed"
                        stopPropagation
                    >
                    </span>
                    <span
                        *ngIf="equalityCheckDataCurrentYear.isMappingProfitIncomeAndProfitFliConsistent"
                        hamIconShapes
                        icon="assets/hamIcons/check-outline.svg"
                        [variant]="'dark-green'"
                        [size]="'xs'"
                        class="check-icons icons-when-closed"
                        stopPropagation
                    >
                    </span>
                    <span
                        *ngIf="!equalityCheckDataCurrentYear.isMappingProfitIncomeAndProfitFliConsistent"
                        hamIconShapes
                        icon="assets/hamIcons/x-red.svg"
                        [variant]="'dark-red'"
                        [size]="'xs'"
                        class="check-icons icons-when-closed"
                        stopPropagation
                    >
                    </span>
                    <ng-container *ngIf="equalityCheckDataCurrentYear.isCashflowStatementTotalsConsistent != null">
                        <span
                            *ngIf="equalityCheckDataCurrentYear.isCashflowStatementTotalsConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/check-outline.svg"
                            [variant]="'dark-green'"
                            [size]="'xs'"
                            class="check-icons icons-when-closed"
                            stopPropagation
                        >
                        </span>
                        <span
                            *ngIf="!equalityCheckDataCurrentYear.isCashflowStatementTotalsConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/x-red.svg"
                            [variant]="'dark-red'"
                            [size]="'xs'"
                            class="check-icons icons-when-closed"
                            stopPropagation
                        >
                        </span>
                    </ng-container>
                    <!-- REV-20899: Reclassifications row removed (transactional model is always balanced). -->
                    <ng-container
                        *ngIf="equalityCheckDataCurrentYear.isAdjustmentsAssetsAndLiabilitiesConsistent != null"
                    >
                        <span
                            *ngIf="equalityCheckDataCurrentYear.isAdjustmentsAssetsAndLiabilitiesConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/check-outline.svg"
                            [variant]="'dark-green'"
                            [size]="'xs'"
                            class="check-icons icons-when-closed"
                            stopPropagation
                        >
                        </span>
                        <span
                            *ngIf="!equalityCheckDataCurrentYear.isAdjustmentsAssetsAndLiabilitiesConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/x-red.svg"
                            [variant]="'dark-red'"
                            [size]="'xs'"
                            class="check-icons icons-when-closed"
                            stopPropagation
                        >
                        </span>
                    </ng-container>
                    <!-- REV-20899: Reclassifications profit-income row removed (transactional model is always balanced). -->
                    <ng-container
                        *ngIf="equalityCheckDataCurrentYear.isAdjustmentsProfitIncomeAndProfitFliConsistent != null"
                    >
                        <span
                            *ngIf="equalityCheckDataCurrentYear.isAdjustmentsProfitIncomeAndProfitFliConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/check-outline.svg"
                            [variant]="'dark-green'"
                            [size]="'xs'"
                            class="check-icons icons-when-closed"
                            stopPropagation
                        >
                        </span>
                        <span
                            *ngIf="!equalityCheckDataCurrentYear.isAdjustmentsProfitIncomeAndProfitFliConsistent"
                            hamIconShapes
                            icon="assets/hamIcons/x-red.svg"
                            [variant]="'dark-red'"
                            [size]="'xs'"
                            class="check-icons icons-when-closed"
                            stopPropagation
                        >
                        </span>
                    </ng-container>
                </span>
                <span *ngIf="!noPreviousYear">
                    <span
                        *ngIf="isPreviousYearConsistent"
                        hamIconShapes
                        icon="assets/hamIcons/check-outline.svg"
                        [variant]="'dark-green'"
                        [size]="'xs'"
                        class="check-icons"
                        stopPropagation
                    ></span>
                    <span
                        *ngIf="!isPreviousYearConsistent"
                        hamIconShapes
                        icon="assets/hamIcons/x-red.svg"
                        [variant]="'dark-red'"
                        [size]="'xs'"
                        class="check-icons"
                        stopPropagation
                    ></span>
                </span>
            </div>
        </div>
    </ham-accordion-item>
</ham-accordion>
